import { ILinkItem } from "app/utils/interfaces";
import InternalMenuAccordion from "./InternalMenu.Accordion";
import { generateMenuList, generatePanelTitleElement } from "./InternalMenu.Functions";
import "./InternalMenu.scss";

interface IProps {
	currentActiveLink: string;
	links: ILinkItem[];
	accordionTitle?: string;
}

const InternalMenuGuides = (props: IProps): JSX.Element => {
	return (
		<div className="internal-menu">
			<div className="internal-menu--list" id="internal-menu--list">
				<div>{generatePanelTitleElement("list", props.accordionTitle || "Contents")}</div>
				{generateMenuList([{ links: props.links }], props.currentActiveLink, "list")}
			</div>
			<InternalMenuAccordion
				linkGroups={[{ links: props.links }]}
				currentActiveLink={props.currentActiveLink}
				accordionTitle={props.accordionTitle || "Contents"}
			/>
		</div>
	);
};

export default InternalMenuGuides;
